import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Loader from '../components/afterLogin/Loader';
import ErrorBoundary from '../components/afterLogin/ErrorBoundary';

import { setFavicon } from '../utils/helpers';
import { sidebarList } from '../components/constants/sidebarList';
import { setAdminData } from '../reducers/adminSlice';
import { setSidebarData } from '../reducers/sidebarSlice';
import { resetContentFilterData } from '../reducers/contentFilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import NavigationBarDashboard from "../components/afterLogin/NavigationBarDashboard";
import MainSidebar from '../components/afterLogin/MainSidebar';
import TopNotificationBar from '../components/afterLogin/TopNotificationBar';
import { getProfileFieldBlocks } from '../api/afterLogin/learners';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { fetchAnalytics } from '../api/analytics';
import { getAnalyticsCode, parseScriptTags } from '../helpers/seo_helper';
import FooterScriptsPortal from '../components/FooterScriptsPortal';

const ClientLayout = ({children}) => {
  const dispatch = useDispatch();
  const adminData = useSelector((state) => state.admin)
  const location = useLocation();
  const enableActiveWrapper = useSelector((state) => state.sidebar.enableActiveWrapper);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const [analytics,setAnalytics]                  = useState('');

  const allowedProducts = adminData && adminData?.products?.filter((item) => 
    new Date(item.expiry_date) > new Date()
  )
  const userSpEnabled = adminData?.user_sp_enabled;  
  const navigate      = useNavigate();
  const configData = useSelector((state) => state.config);
  const [profileFieldBlocks, setProfileFieldBlocks] = useState({});
  const learnerProfileFields = configData.session.us_profile_fields;
  const profileFields = learnerProfileFields && learnerProfileFields !== null ? learnerProfileFields.split("{#}") : false;
  const userProfileFieldData = {};
  if (profileFields) {
      profileFields.forEach((field) => {
        field = field.substring(2, field.length - 2);
        if (field != "{=>}") {
          const tempField = field.split("{=>}");
          const key = tempField[0] || 0;
          const value = tempField[1] || "";
          userProfileFieldData[key] = value;
        }
      });
  }
  const loadProfileFieldBlocks = async () => {
    const profileProfileblocks = await getProfileFieldBlocks(
      configData.access_token
    );
    if (profileProfileblocks) {
      setProfileFieldBlocks(profileProfileblocks);
    }
  };
  useEffect(() => {
    loadProfileFieldBlocks();
  }, []);

  useEffect(() => {
    const hasMissingMandatoryFields = Object.values(profileFieldBlocks || {}).some((block) =>
      block.profile_fields?.some((field) => {
        if (field.pf_mandatory === "1") {
          const fieldKey = field.id;
          return !userProfileFieldData[fieldKey] || userProfileFieldData[fieldKey] === "";
        }
        return false;
      })
    );

    const addressMandatory = configData?.address_mandatory === "1";
    const phnoMandatory = configData?.phno_mandatory === "1";
    const userAddress = configData?.session?.us_address;
    const isAddressMissing = !userAddress || Object.keys(userAddress).length === 0;
    const userPhone = configData?.session?.us_phone;
    const userCountryCode = configData?.session?.us_country_code;
    const isPhoneMissing = !userPhone || userPhone.trim() === "" || !userCountryCode || userCountryCode.trim() === "";
    const shouldDisableSidebar = hasMissingMandatoryFields || (addressMandatory && isAddressMissing) || (phnoMandatory && isPhoneMissing);

    dispatch(setSidebarData({ isSidebarDisable: shouldDisableSidebar }));
  }, [profileFieldBlocks, learnerProfileFields, configData]);
  const sidebarData = useSelector((state) => state.sidebar.isSidebarDisable);
  if (sidebarData === true && location.pathname !== '/student-dashboard') {
      navigate('/student-dashboard');
  }
  
  // useEffect(() => {
  //   const { header, profile, product, products } = {};

  //   dispatch(setAdminData({ header, profile, product, products }));
  //   setFavicon(header?.fav_icon);
  // }, [dispatch]);

  useEffect(() => {
    const actPath = sidebarList.find((s) => s.link === location.pathname || location.pathname.includes(`${s.link}/`));
    const enableActive = actPath && actPath.isDynamic;
    dispatch(setSidebarData({ enableActiveWrapper: enableActive }));
    dispatch(resetContentFilterData());
  }, [dispatch, location.pathname]);

  useEffect(() => {
    const analyticsData = async () => {
      const analytics = await fetchAnalytics(miscellaneous.account_id);
      setAnalytics(analytics);
    };
    analyticsData();
  }, []);

  return (
    <>
      {/* Header Script */}
      <Helmet>
        {getAnalyticsCode(analytics, "header").map(({ name, code }) => {
          const scriptBlocks = parseScriptTags(code);
          return scriptBlocks.map((script, idx) => {
            return(
              <script key={`${name}-${idx}`} {...script.props}>
                {script.content}
              </script>
            )
          })
        })}
      </Helmet>
      <TopNotificationBar className="global-topbar"/>
      <NavigationBarDashboard />
      {adminData.account_id !== '' && adminData.us_uid !== '' && (
      <main className={enableActiveWrapper ? 'main-wrapper active-wrapper' : 'main-wrapper'}>
        <MainSidebar sidebarList={sidebarList} allowedProducts={allowedProducts} userSpEnabled={userSpEnabled} />
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      )}
      {/* Footer Script */}
      <FooterScriptsPortal analytics={analytics} />
    </>
  );
}

export default ClientLayout;
